<div
  class="position-relative"
  [class.active]="isOpened"
>
  @if (label && showLabel) {
    <div class="mb-2">
      @if (isRequired) {
        <span
          class="text-danger"
          aria-hidden="true"
        >
          *
        </span>
      }

      <span class="fw-bold">
        {{ label }}
      </span>
    </div>
  }

  <!-- Dropdown toggle -->
  <button
    type="button"
    class="
      form-control
      d-flex
      justify-content-between
      align-items-center
      text-start
      c-pointer
    "
    [disabled]="disabled"
    [attr.aria-label]="
      label ||
      ('DROPDOWN.SelectOptionAreaLabel' | translate)
    "
    [attr.aria-expanded]="isOpened"
    [attr.aria-required]="isRequired"
    aria-haspopup="listbox"
    (click)="toggle()"
  >
    <span class="d-flex align-items-center">
      @if (selectedItem) {
        <ng-container
          [ngTemplateOutlet]="selectedItemTemplate"
          [ngTemplateOutletContext]="{
            $implicit: selectedItem
          }"
        ></ng-container>
      } @else {
        <span class="text-black-50 fs-7 user-select-none">
          @if (placeHolder) {
            <ng-container
              [ngTemplateOutlet]="placeHolder"
            ></ng-container>
          } @else {
            <span class="dd-placeHolder">
              {{
                'DROPDOWN.SelectOption'
                  | translate: { label: label }
              }}
            </span>
          }
        </span>
      }
    </span>

    <i
      class="icon-chevron-down"
      aria-hidden="true"
    ></i>
  </button>

  @if (isOpened) {
    <div
      class="
        dropdown-menu-adaptive
        border
        rounded
        position-absolute
        bg-body
      "
    >
      @if (searchable) {
        <div class="p-4 pb-0 mb-4">
          <input
            #searchInput
            type="text"
            class="form-control"
            [(ngModel)]="searchValue"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="disabled"
            [placeholder]="
              'DROPDOWN.Search'
                | translate: {
                    label: searchLabel || label
                  }
            "
            [attr.aria-label]="
              'DROPDOWN.Search'
                | translate: {
                    label: searchLabel || label
                  }
            "
            [libInputFilter]="searchInputFilter"
            (input)="onSearchInput($event)"
          />
        </div>
      }

      @if (items.length > 0) {
        <ul class="px-0 m-0 list-unstyled">
          @for (item of items; track $index) {
            <li>
              <button
                type="button"
                class="
                  dropdown-item
                  w-100
                  border-0
                  bg-transparent
                  text-start
                  p-0
                  c-pointer
                "
                (click)="selectItem(item)"
              >
                <ng-container
                  [ngTemplateOutlet]="itemTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: item
                  }"
                ></ng-container>
              </button>
            </li>
          }
        </ul>
      } @else {
        <div class="p-5 text-start">
          {{ 'DROPDOWN.NoItems' | translate }}
        </div>
      }
    </div>
  }
</div>

@if (myControl?.touched && myControl?.errors) {
  <ul class="text-danger mt-2 p-0 mb-0 text-start">
    @if (myControl?.errors?.['required']) {
      <li>
        {{
          'VALIDATION.Required'
            | translate: { label: label }
        }}
      </li>
    }

    @if (myControl?.errors?.['max']; as maxError) {
      <li>
        {{
          'VALIDATION.Max'
            | translate: { max: maxError.max }
        }}
      </li>
    }
  </ul>
}
